module.exports = __webpack_public_path__ + "static/media/planning&simulation.7dd6c26c.svg";